<div class="g-0" *ngIf="cerere?.etape?.length">
    <div class="col">
        <div class="box-wrapper box-etape">
            <div class="box-content-header">
                <div class="row p-1">
                    <div class="col d-flex align-items-center justify-content-between">
                        <mat-card-title>
                            <i class="fa-solid fa-list-check"></i>
                            <span>Etape Decontare — {{ getProgramLabel() }}</span>
                        </mat-card-title>
                        <span class="program-badge" [ngClass]="getBadgeClass()">{{ getProgramBadge() }}</span>
                    </div>
                </div>
            </div>
            <div class="box-content-body">

                <!-- Info specifice program -->
                <div class="program-info" *ngIf="cerere.special_payload">
                    <div *ngIf="cerere.special_payload.numar_auto" class="info-row">
                        <span class="info-label">Vehicul:</span>
                        <strong>{{ cerere.special_payload.numar_auto }}</strong>
                        <span *ngIf="cerere.special_payload.cc_dgitl_category" class="text-muted ms-1">
                            · {{ cerere.special_payload.cc_dgitl_category }} cm³
                        </span>
                    </div>
                    <div *ngIf="cerere.special_payload.tip_transport" class="info-row">
                        <span class="info-label">Tip abonament:</span>
                        <strong>{{ getTipTransportLabel() }}</strong>
                    </div>
                    <div *ngIf="cerere.special_payload.iban" class="info-row">
                        <span class="info-label">IBAN:</span>
                        <strong>{{ cerere.special_payload.iban }}</strong>
                        <span *ngIf="cerere.special_payload.banca" class="text-muted ms-1">
                            · {{ cerere.special_payload.banca }}
                        </span>
                    </div>
                </div>

                <mat-divider *ngIf="cerere.special_payload"></mat-divider>

                <!-- Etape -->
                <div class="etape-list p-3">
                    <div *ngFor="let etapa of cerere.etape" class="etapa-row" [class.locked]="isLocked(etapa)"
                        [class.completed]="isEtapaFullyCompleted(etapa)">

                        <!-- Header -->
                        <div class="etapa-header">
                            <div class="etapa-nr" [class.nr-completed]="isEtapaFullyCompleted(etapa)">
                                <span *ngIf="!isEtapaFullyCompleted(etapa)">{{ etapa.nr }}</span>
                                <mat-icon *ngIf="isEtapaFullyCompleted(etapa)" class="check-icon">check</mat-icon>
                            </div>
                            <div class="etapa-info">
                                <strong>Etapa {{ etapa.nr }} — {{ etapa.label }}</strong>
                                <span class="perioada">{{ etapa.perioada }}</span>
                            </div>
                            <!-- Badge plată -->
                            <span class="status-badge" [ngClass]="'badge-' + etapa.status">
                                {{ etapa.status_label }}
                            </span>
                        </div>

                        <!-- LOCKED state (calendar-future SAU cerere not validated) -->
                        <ng-container *ngIf="isLocked(etapa)">
                            <div class="locked-info">
                                <mat-icon>lock</mat-icon>
                                <!-- Cerere not validated -->
                                <span *ngIf="!cerere?.validated_date">
                                    Blocată — așteaptă validarea cererii de către operator.
                                </span>
                                <!-- Cerere validated dar etapă viitoare (perioada_start > today) -->
                                <span *ngIf="cerere?.validated_date && isFutureEtapa(etapa)">
                                    Etapă viitoare — se deschide pe {{ formatPerioadaStartShort(etapa) || etapa.perioada }}.
                                </span>
                                <!-- Caz fallback (etapa unlocked=false dar perioada începută — edge case) -->
                                <span *ngIf="cerere?.validated_date && !isFutureEtapa(etapa)">
                                    Etapă blocată — verificați starea și deblocați manual dacă e necesar.
                                </span>
                            </div>
                            <div class="etapa-actions" *ngIf="cerere?.validated_date">
                                <button
                                    *ngIf="permissionsService.hasPermission('dgaspc-module.cerere.cerere-view.ajutor-deblocheaza-manual')"
                                    mat-stroked-button (click)="unlockEtapa(etapa)">
                                    <mat-icon>lock_open</mat-icon> Deblochează manual
                                </button>
                            </div>
                        </ng-container>

                        <!-- UNLOCKED state -->
                        <ng-container *ngIf="!isLocked(etapa)">

                            <!-- Sumă decont -->
                            <div class="decont-info" *ngIf="etapa.payment_amount">
                                <mat-icon>account_balance_wallet</mat-icon>
                                <span>Sumă decont: <strong>{{ etapa.payment_amount }} lei</strong></span>
                            </div>
                            <div class="decont-info decont-missing" *ngIf="!etapa.payment_amount">
                                <mat-icon>info_outline</mat-icon>
                                <span>Sumă nespecificată</span>
                            </div>

                            <!-- Dual badges row: plată + documente -->
                            <div class="dual-status"
                                *ngIf="etapa.docs_status !== 'not_uploaded' || etapa.status === 'paid'">
                                <span class="docs-badge" [ngClass]="'docs-badge-' + etapa.docs_status">
                                    {{ etapa.docs_status_label }}
                                </span>
                            </div>

                            <!-- Documente încărcate -->
                            <div class="etapa-docs"
                                *ngIf="etapa.doc_extras_bancar_doc || etapa.doc_bonuri_docs?.length">
                                <div *ngIf="etapa.doc_extras_bancar_doc" class="doc-item">
                                    <mat-icon class="doc-icon">description</mat-icon>
                                    <a *ngIf="etapa.doc_extras_bancar_doc.id" class="doc-link"
                                        (click)="downloadDocument(etapa.doc_extras_bancar_doc.id)">
                                        {{ etapa.doc_extras_bancar_doc.old_name || 'Extras bancar' }}
                                    </a>
                                    <span *ngIf="!etapa.doc_extras_bancar_doc.id">{{
                                        etapa.doc_extras_bancar_doc.old_name }}</span>
                                </div>
                                <ng-container *ngIf="etapa.doc_bonuri_docs?.length">
                                    <div *ngFor="let bon of etapa.doc_bonuri_docs" class="doc-item">
                                        <mat-icon class="doc-icon">receipt</mat-icon>
                                        <a *ngIf="bon.id" class="doc-link" (click)="downloadDocument(bon.id)">
                                            {{ bon.old_name || 'Document' }}
                                        </a>
                                        <span *ngIf="!bon.id">{{ bon.old_name }}</span>
                                    </div>
                                </ng-container>
                            </div>

                            <!-- Info plată -->
                            <div class="payment-info" *ngIf="etapa.payment_date">
                                <mat-icon color="primary">payments</mat-icon>
                                <span>Plătit: {{ etapa.payment_amount }} lei — {{ etapa.payment_date }}</span>
                                <small *ngIf="etapa.payment_ref" class="text-muted ms-2">Ref: {{ etapa.payment_ref
                                    }}</small>
                            </div>

                            <!-- Info aprobare documente -->
                            <div class="approved-info" *ngIf="etapa.docs_status === 'approved' && etapa.approved_date">
                                <mat-icon color="primary">check_circle</mat-icon>
                                <span>Documente aprobate: {{ etapa.approved_date }}</span>
                            </div>

                            <!-- Motiv respingere -->
                            <div class="rejected-info" *ngIf="etapa.docs_status === 'rejected'">
                                <mat-icon color="warn">warning</mat-icon>
                                <span>Respins: {{ etapa.rejected_reason }}</span>
                                <small class="text-muted ms-2">{{ etapa.rejected_date }}</small>
                                <span *ngIf="etapa.allow_reupload" class="reupload-badge ms-2">Așteaptă
                                    re-încărcare</span>
                            </div>

                            <!-- Recovery info (plată confirmată — recuperare sume) -->
                            <div class="recovery-info" *ngIf="etapa.docs_status === 'recovery'">
                                <mat-icon color="warn">error_outline</mat-icon>
                                <span>Recuperare sume: {{ etapa.recovery_amount }} lei</span>
                                <small class="text-muted ms-2">{{ etapa.rejected_reason }}</small>
                            </div>

                            <!-- Etapă anulată (respinsă definitiv, plata nu s-a făcut) -->
                            <div class="rejected-info" *ngIf="etapa.status === 'cancelled' && etapa.docs_status === 'rejected' && !etapa.allow_reupload">
                                <mat-icon color="warn">block</mat-icon>
                                <span>Etapă anulată — fără sume de recuperat.</span>
                                <small class="text-muted ms-2" *ngIf="etapa.rejected_reason">Motiv: {{ etapa.rejected_reason }}</small>
                            </div>

                            <!-- Paid but no docs yet (bypass case — sub regula calendar
                                 cetățeanul poate încărca documente retroactiv). -->
                            <div class="waiting-info"
                                *ngIf="etapa.status === 'paid' && etapa.docs_status === 'not_uploaded'">
                                <mat-icon>hourglass_empty</mat-icon>
                                <span>Plată anticipată — așteaptă documente justificative de la cetățean.</span>
                            </div>

                            <!-- Status=pending: sub-branching după sub-stare (regula calendar) -->
                            <ng-container *ngIf="etapa.status === 'pending'">
                                <!-- Cerere not validated -->
                                <div class="waiting-info" *ngIf="!cerere?.validated_date">
                                    <mat-icon>hourglass_empty</mat-icon>
                                    <span>Cererea este în validare la operator.</span>
                                </div>
                                <!-- Validated + activă calendaristic + nu sunt încărcate -->
                                <div class="waiting-info"
                                    *ngIf="cerere?.validated_date && etapa.docs_status === 'not_uploaded' && !isPastEtapaWithoutDocs(etapa)">
                                    <mat-icon>hourglass_empty</mat-icon>
                                    <span>Activă — așteaptă documentele cetățeanului.</span>
                                </div>
                                <!-- Validated + perioada trecută + nimic încărcat (cetățeanul poate încărca retroactiv) -->
                                <div class="waiting-info"
                                    *ngIf="cerere?.validated_date && isPastEtapaWithoutDocs(etapa)">
                                    <mat-icon>history</mat-icon>
                                    <span>Trecută fără documente — cetățeanul poate încărca retroactiv până la finalul programului.</span>
                                </div>
                                <!-- Documente trimise — așteaptă verificare operator -->
                                <div class="waiting-info"
                                    *ngIf="cerere?.validated_date && etapa.docs_status === 'uploaded'">
                                    <mat-icon>fact_check</mat-icon>
                                    <span>Documente încărcate — așteaptă verificarea operatorului.</span>
                                </div>
                            </ng-container>

                            <!-- In batch processing -->
                            <div class="batch-info" *ngIf="etapa.status === 'payment_pending'">
                                <mat-icon>schedule</mat-icon>
                                <span>În lot decontare — procesare plată</span>
                            </div>

                            <!-- ═══ ACȚIUNI OPERATOR (doar după validare) ═══ -->
                            <div *ngIf="!cerere?.validated_date" class="etapa-info-msg">
                                <mat-icon>info</mat-icon> <span>Cererea trebuie validată pentru procesarea etapelor.</span>
                            </div>

                            <!-- Docs uploaded → approve/reject -->
                            <div class="etapa-actions" *ngIf="etapa.can_process_docs && cerere?.validated_date">
                                <button
                                    *ngIf="permissionsService.hasPermission('dgaspc-module.cerere.cerere-view.ajutor-aproba-documente')"
                                    mat-raised-button color="primary" (click)="approveDocs(etapa)">
                                    <mat-icon>check_circle</mat-icon> Aprobă documente
                                </button>
                                <button
                                    *ngIf="permissionsService.hasPermission('dgaspc-module.cerere.cerere-view.ajutor-respinge-documente')"
                                    mat-raised-button color="warn" (click)="rejectDocs(etapa)">
                                    <mat-icon>cancel</mat-icon> Respinge documente
                                </button>
                            </div>

                            <!-- Ready for payment → confirm individual payment -->
                            <div class="etapa-actions" *ngIf="etapa.status === 'ready_for_payment' && cerere?.validated_date">
                                <button
                                    *ngIf="permissionsService.hasPermission('dgaspc-module.cerere.cerere-view.ajutor-confirma-plata')"
                                    mat-raised-button color="accent" (click)="confirmPayment(etapa)">
                                    <mat-icon>payments</mat-icon> Confirmă plata
                                </button>
                            </div>

                        </ng-container>

                    </div>
                </div>

            </div>
        </div>
    </div>
</div>